import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jwt } from "../utils/index.js";

// List of allowed paths for Kentro users
const ALLOWED_PATHS = [
  "/home",
  "/info/animal/registration",
  "/info/owner/population",
  "/info/male/tree",
  "/info/animal/relatives",
  "/info/owner/population/detailed",
];

export default function KentroGuard({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!jwt.isAuthenticated()) return;

    async function check() {
      const isKentroUser = await jwt.isKentroUser();
      if (isKentroUser) {
        const allowed = ALLOWED_PATHS.some((allowedPath) =>
          location.pathname.startsWith(allowedPath)
        );
        if (!allowed) {
          navigate("/home", { replace: true });
        }
      }
    }
    check();
    // Only run on location change
    // eslint-disable-next-line
  }, [location.pathname]);

  return children;
}
